import { 
        InfoContainer8, 
        InfoContainer_2,
        InfoWrapper, 
        InfoRow, 
        InfoRow2,
        InfoRow3,
        Column1, 
        Column2,
        TextWrapper, 
        TextWrapper2, 
        Heading, 
        Subtitle, 
        ImgWrap, 
        Img,
        Img2
} from './InfoElements8'

const InfoSection8 = ({ headline, headline2, headline3, description, description2, description3, img, img2, img3, alt }) => {
  return (
    <>
       <InfoContainer8>
            <InfoWrapper id='about'>
                <InfoRow>
                    <Column1>
                        <TextWrapper>
                            <Heading>{headline}</Heading>
                            <Subtitle>{description}</Subtitle>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer8> 

       <InfoContainer_2>
            <InfoWrapper id='about'>
                <InfoRow2>
                    <Column1>
                        <ImgWrap>
                            <Img2 src={img2} alt={alt} />
                        </ImgWrap>  
                    </Column1>
                    <Column2>
                        <TextWrapper2>
                            <Heading>{headline2}</Heading>
                            <Subtitle>{description2}</Subtitle>
                        </TextWrapper2>
                    </Column2>
                </InfoRow2>
            </InfoWrapper>
        </InfoContainer_2> 

         <InfoContainer8>
            <InfoWrapper id='about'>
                <InfoRow3>
                    <Column1>
                        <TextWrapper>
                            <Heading>{headline3}</Heading>
                            <Subtitle>{description3}</Subtitle>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img2 src={img3} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </InfoRow3>
            </InfoWrapper>
        </InfoContainer8> 
    </>
  )
}

export default InfoSection8